import * as React from 'react';
import { hideNotification, showFavoritesFoldersList } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectSavedInFolders, selectSavedOfferId, selectUserHasFolders } from '../../selectors';
import { AddButton } from '../../components/AddButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function ChangeFolderButtonContainer(_ref) {
  var showIcon = _ref.showIcon,
    onChangeFolder = _ref.onChangeFolder,
    onSaveToFolder = _ref.onSaveToFolder;
  var dispatch = useDispatch();
  var offerIds = useSelector(selectSavedOfferId);
  var savedInFolders = useSelector(selectSavedInFolders);
  var userHasFolders = useSelector(selectUserHasFolders);
  var handleSaveClick = React.useCallback(function () {
    dispatch(hideNotification());
    dispatch(showFavoritesFoldersList({
      offerIds: offerIds
    }));
    // Проблему покрытия тут решают тайпинги и не дадут написать код так, чтобы вызвать метод без проверки
    /* istanbul ignore next */
    if (onSaveToFolder) {
      onSaveToFolder();
    }
  }, [onSaveToFolder]);
  var handleChangeClick = React.useCallback(function () {
    dispatch(hideNotification());
    dispatch(showFavoritesFoldersList({
      offerIds: offerIds
    }));
    // Проблему покрытия тут решают тайпинги и не дадут написать код так, чтобы вызвать метод без проверки
    /* istanbul ignore next */
    if (onChangeFolder) {
      onChangeFolder();
    }
  }, [onChangeFolder]);
  if (!savedInFolders && userHasFolders && showIcon) {
    return /*#__PURE__*/_jsx(AddButton, {
      text: "\u0421\u043E\u0445\u0440. \u0432 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0443",
      showIcon: true,
      onClick: handleSaveClick
    });
  }
  return /*#__PURE__*/_jsx("button", {
    onClick: handleChangeClick,
    children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C"
  });
}